/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planvereinmdescription3Inputs */

const en_planvereinmdescription3 = /** @type {(inputs: Planvereinmdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For clubs and student groups up to 500 members`)
};

const de_planvereinmdescription3 = /** @type {(inputs: Planvereinmdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Vereine und Hochschulgruppen bis 500 Mitglieder`)
};

/**
* | output |
* | --- |
* | "For clubs and student groups up to 500 members" |
*
* @param {Planvereinmdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planvereinmdescription3 = /** @type {((inputs?: Planvereinmdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planvereinmdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planvereinmdescription3(inputs)
	return de_planvereinmdescription3(inputs)
});
export { planvereinmdescription3 as "planVereinMDescription" }